import { Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import moment from 'moment';
import { ExcelService } from 'src/app/services/excel.service';
import { LookupDataServiceService } from 'src/app/services/lookup-data-service.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { NotificationService } from 'src/app/services/notification-service';
import { LoaderService } from 'src/app/shared/services/loader.service';
import { ProductDetailsPopupComponent } from '../product-details-popup/product-details-popup.component';
import { CustomDatePopupComponent } from '../custom-date-popup/custom-date-popup.component';
import { elementAt } from 'rxjs';
import { Element } from '@angular/compiler/src/render3/r3_ast';


@Component({
  selector: 'app-rain-itemized-billing',
  templateUrl: './rain-itemized-billing.component.html',
  styleUrls: ['./rain-itemized-billing.component.scss'],

})
export class RainItemizedBillingComponent implements OnInit {
  form: FormGroup;
  data = [];
  dataSource = new MatTableDataSource(this.data);
  dataExcel: any = [];
  excelColumns: string[];
  displayedColumns: string[] = [
    "ApplicationNumber",
    "ConnectionActivationDate",
    "CustomerName",
    "RainUsername",
    "Comments",
    "CourierReference",
    "SIMNumber",
    "Action"
  ];
  isFromLoginPage = false
  selectedOption: any;
  currentMonthYear: any;
  Month = moment().format('MMM YYYY');
  month = this.Month
  lastMonth: string = moment().subtract(1, 'months').format('MMM YYYY');
  Year = moment(this.Month, 'MMM YYYY').format('YYYY');
  date = [
    { key: "1", value: "Current Month", datevalue: 'Sep 2024' },
    { key: "2", value: "Last Month", datevalue: 'AUg 2024' },
    { key: "3", value: "Custom", datevalue: 'Dec 2024' },


  ]
  @ViewChild('popupContainer')popupContainer:ElementRef 
  dropdownOpen = false;
  custom: any;
  selected: boolean = false
  constructor(
    private lookupDataService: LookupDataServiceService,
    private loaderService: LoaderService,
    private toastr: NotificationService,
    private excelService: ExcelService,
    private navigationService: NavigationService,
    private formBuilder: FormBuilder,
    private matdialog: MatDialog,
    private renderer:Renderer2

  ) { }

  ngOnInit(): void {
    this.renderer.listen('document', 'click', (event) => {
      if (this.dropdownOpen && !this.popupContainer.nativeElement.contains(event.target)) {
          this.dropdownOpen = false;
      }
  });
    this.form = this.formBuilder.group({
      month: [null]
    })
    this.gettabledata();
  }
  toggleDropdown() {
    this.dropdownOpen = this.dropdownOpen ? false : true;
  }

  selectMonth(option) {
    debugger
    const months = [this.month, this.lastMonth, this.custom];
    this.Month = months[option];
    this.dropdownOpen = false;
    if (option == 0) {
      this.Month = moment().format('MMM YYYY')
      this.gettabledata()

    }
    else if (option == 1) {
      this.Month = moment().subtract(option, 'months').date(1).format('MMM YYYY')
      this.gettabledata()

    }
    else {
      const dialogref = this.matdialog.open(CustomDatePopupComponent, {
        autoFocus: false,
        disableClose: true,
        panelClass: 'mat-dialog',
        width: "30%",
        data: {
          head: 'Custom Date',
          title: 'date',
        }
      });
      dialogref.afterClosed().subscribe((result) => {
        this.Month = result;
        this.gettabledata()


      })
    }
  }
  onDateChange() {

    console.log("valuess-", this.form.value);

    if (this.form.value.month == 1) {
      this.month = this.Month;
    }
    if (this.form.value.month == 2) {
      this.month = this.lastMonth;
    }
    if (this.form.value.month == 3) {
      const dialogref = this.matdialog.open(CustomDatePopupComponent, {
        autoFocus: false,
        disableClose: true,
        panelClass: 'mat-dialog',
        width: "30%",
        data: {
          head: 'Custom Date',
          title: 'date',
        }
      });
      dialogref.afterClosed().subscribe((result) => {
        this.month = result;

      })
    }
    this.form.patchValue({
      month: null
    })
    this.gettabledata()
  }
  gettabledata() {
    console.log('hit')
    // var postData:any = {};

    // postData.selectedMonthYear = moment(this.Month, 'MMM YYYY').format('MM-DD-YYYY');
    // this.lookupDataService.getRainItemizedBillingList(postData).subscribe((result)=>{
    //   this.date=result;
    //   this.dataExcel=result;
    //   this.dataSource=new MatTableDataSource(this.data);

    // })
  }
  gotoaddactivity(data) { }
  clearFilter() {
    this.gettabledata();
  }
  exportAsXLSX(): void {
    this.loaderService.start();
    setTimeout(() => {
      var exportData = this.dataExcel;
      if (!exportData || exportData.length === 0) {
        this.toastr.showInfo("No data available to export");
        this.loaderService.hide();
        return;
      }
      const excelList = [];
      this.excelColumns = [
        "S.No",
        "Application Number",
        "Connection Activation Date",
        "Customer Name",
        "RainUser Name",
        "Comments",
        "Courier Reference",
        "SIM Number",

      ];
      exportData.forEach((a, index) => {

        excelList.push({
          sno: ++index,
          "Application Number": a.applicationNumber,
          "Connection Activation Date": a.connectionActivationDate,
          "Customer Name": a.customerName,
          "RainUser Name": a.dslUserName,
          "Comments": a.annotation,
          "Courier Reference": a.courierRef,
          "SIM Number": a.sIMNumber,

        });
      });
      this.excelService.exportAsExcelFile(excelList, "ChangeServiceRequest_" + moment().format("DDMMYYYYHHmmss") + '.xlsx', this.excelColumns);
      this.loaderService.stop();
    }, 500);
  }
}
